import React from 'react';
import { PropsType } from 'js/types/react';
import { City } from './City';
import styles from './CityBlocks.module.css';

interface Props {
  cities: Pick<PropsType<City>, 'name' | 'normalisedName' | 'treatmentTypes'>[];
  onCitySelect?: (cityNormalisedName: string) => void;
  onTreatmentTypeSelect?: (
    cityNormalisedName: string,
    treatmentTypeName: string
  ) => void;
}

interface State {
  openCity?: string;
}

export class CityBlocks extends React.PureComponent<Props, State> {
  public state: State = {
    openCity: undefined,
  };

  public onTreatmentTypeSelect = (treatmentTypeName: string): void => {
    if (this.props.onTreatmentTypeSelect && this.state.openCity) {
      this.props.onTreatmentTypeSelect(this.state.openCity, treatmentTypeName);
    }
  };

  public onClick = (cityNormalisedName: string): void => {
    const openCity =
      this.state.openCity === cityNormalisedName
        ? undefined
        : cityNormalisedName;

    this.setState({ openCity }, () => {
      if (openCity && this.props.onCitySelect) {
        this.props.onCitySelect(openCity);
      }
    });
  };

  public render(): React.ReactNode {
    return (
      <div className={styles.flexContainer}>
        {this.props.cities.map(
          (city): React.ReactNode => (
            <City
              key={city.normalisedName}
              name={city.name}
              normalisedName={city.normalisedName}
              treatmentTypes={city.treatmentTypes}
              onClick={this.onClick}
              isOpen={this.state.openCity === city.normalisedName}
              onTreatmentTypeSelect={this.onTreatmentTypeSelect}
            />
          )
        )}
      </div>
    );
  }
}
